import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { expandCollpaseAnimation } from '../../animations';
import { headerItems, sidebarItems } from './sidebar-items';
import { AuthRole, AuthService } from '@app/modules/auth';
import { MbPlansService } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.service';
import { ConfigurationService } from '@app/_shared/providers';
import { DASHBOARD_PATH, SVGPathMap, WHATS_NEW_PATH, UTRADE_ONE_AI_PATH, OPERATOR_DASHBOARD_PATH, StorageHelper } from '@app/_helpers';
import { fromEvent, Subscription } from 'rxjs';
import { SideBarItemI } from './sidebar.interfaces';
import { MixpanelService } from '@app/_shared/providers/mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from '@app/_shared/providers/mixpanel/mixpanel.events';
import { MarketPlaceService } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  animations: [
    expandCollpaseAnimation
  ]
})
export class SideBarComponent implements OnInit, OnDestroy {

  @Input() expanded: boolean;
  headerItems = sidebarItems;
  activeUrl: string;
  isAdmin = false
  userName: string;
  @Output() toggleMenu = new EventEmitter<boolean>();
  logoSrc = SVGPathMap.logo_extended;
  subscriptions = new Subscription();

  constructor(
    private router: Router,
    public authService: AuthService,
    private mbPlansService: MbPlansService,
    private configurationService: ConfigurationService,
    private mixpanel: MixpanelService,
    private marketPlaceService: MarketPlaceService
  ) {
    this.userName = this.authService.accessTokenObj?.clientId.toUpperCase();
    this.isAdmin = this.authService.accessTokenObj?.role === AuthRole.ADMIN;
    if (this.userName && !this.isAdmin) {
      // Check for external strategy permission
      this.mbPlansService.getUserDetails().subscribe((res => {

        // if (res.isOneAiAllowed()) {
        //   this.headerItems.find(item => item.route === UTRADE_ONE_AI_PATH).visible = true;
        // }

        const operatorTokenExist = StorageHelper.operatorToken;
        if (operatorTokenExist) {
          this.headerItems.find(item => item.route === OPERATOR_DASHBOARD_PATH).visible = true;
        }
      }))
    }
  }

  ngOnInit(): void {
    this.activeUrl = this.router.url;
    this.subscriptions.add(
      this.router.events.pipe(
        filter(e => e instanceof NavigationEnd)
      ).subscribe((ev: NavigationEnd) => {
        this.activeUrl = ev.urlAfterRedirects;
      })
    );
    
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((ev: NavigationEnd) => {
      this.activeUrl = ev.urlAfterRedirects;
    });

    this.configurationService.getServerConfig().subscribe((res) => {
      const item = headerItems.find(item => item.route === WHATS_NEW_PATH);
      item ? item.visible = Boolean(res.config_params.WHATS_NEW_LINK) : null;
    })

    this.subscriptions.add(
        fromEvent(window, 'resize')
            .pipe(debounceTime(100))
            .subscribe(() => {
                if(this.expanded && window.innerWidth > 1200) {
                    this.closeDrawer();
                }
            })
    );
  }

  redirectToHome() {
    this.closeDrawer();
    this.router.navigate([DASHBOARD_PATH]);
  }

  closeDrawer() {
    this.toggleMenu.emit(false);
  }

  onBackdropClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.closeDrawer();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  
  navigateToComponent(item: SideBarItemI) {
    this.router.navigate([item.route]);
    this.closeDrawer();
    try {
      if (item.event) {
        switch (item.event) {
          case MIXPANEL_EVENTS.NAVIGATE_PORTFOLIOS:
            const tabIndex = StorageHelper.currentStrategyTab
            this.mixpanel.track(item.event, { section: this.marketPlaceService.portfolioTabsIndices[tabIndex] });
            break;
          case MIXPANEL_EVENTS.NAVIGATE_PAY_OFF_CURVE:
            this.mixpanel.track(item.event, { from: "Dashboard" });
            break;
          case MIXPANEL_EVENTS.NAVIGATE_MARGIN_CALCULATOR:
            this.mixpanel.track(item.event, { from: "Dashboard" });
            break;
          default:
            this.mixpanel.track(item.event);
            break;
        }
      }
    } catch (error) { }
  }
}
